import { CalendarClock } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

/**
 * A slim, high-visibility banner reminding visitors the showroom is
 * "By appointment only". Sits just under the navbar on interior pages.
 */
export default function AppointmentBanner() {
  const { t, lang } = useLang();
  const text = {
    fr: "Showroom Rhode-Saint-Genèse · Uniquement sur rendez-vous",
    nl: "Showroom Sint-Genesius-Rode · Enkel op afspraak",
    en: "Showroom Rhode-Saint-Genèse · By appointment only",
  }[lang] || "Showroom Rhode-Saint-Genèse · Uniquement sur rendez-vous";
  const cta = { fr: "Prendre rendez-vous", nl: "Afspraak maken", en: "Book an appointment" }[lang] || "RDV";

  return (
    <div data-testid="appointment-banner" className="bg-[#C8A75A] text-black">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-2.5 flex items-center justify-center gap-3 text-xs md:text-sm">
        <CalendarClock className="w-4 h-4 flex-shrink-0" strokeWidth={2} />
        <span className="font-medium uppercase tracking-[0.15em]">{text}</span>
        <span className="hidden md:inline text-black/50">·</span>
        <a href="/contact" className="hidden md:inline underline underline-offset-4 hover:text-white transition-colors font-medium">
          {cta}
        </a>
      </div>
    </div>
  );
}
